var t = "_stepChangeContainer_iy4ym_1",
  e = "_text_iy4ym_8",
  n = {
    stepChangeContainer: t,
    text: e
  };
export { n as default, t as stepChangeContainer, e as text };